import * as actionTypes from '../actionTypes';

const initialState = {
    lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'bg',
    isUserLogged: localStorage.getItem('id_token') ? true : false,
}

const commonReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LANG_CHANGE:
            return {
                ...state,
                lang: action.lang
            }
        case actionTypes.USER_LOGIN:
            return {
                ...state,
                isUserLogged: true,
            }
        case actionTypes.USER_LOGOUT:
            return {
                ...state,
                isUserLogged: false
            }
    }

    return state;
}

export default commonReducer;